import styled from "styled-components";

export const StyledHeaderWrapper = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 5.5%;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
  background: #fff;
  position: fixed;
  width: 100%;
  max-width: 1920px;
  z-index: 99;
  font-family: ${(props) => props.customFont ? props.customFont : "sans-serif"};

  .brand-logo {
    display: block;
    max-height: 50px;
    margin: auto;
    width: 100%;
  }

  @media (max-width: 800px) {
    .brand-logo {
      padding: 0 10px;
      width: 100px;
    }
  }
`;